// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2USW6","label":"CategoryService_label__cFpul","location":"CategoryService_location__1e_8d"};